<template>
<div id="ticket-page">
    <ul>
        <li class="ticket-list" v-for="item in ticketList"
                :class="{active: item.couponDone}"
                @click="coupon(item.activityId, item.activitySecretKey, item.couponDone)">
            <div class="ticket-h">
                <span>￥</span>
                <span>{{item.couponValue}}</span>
                <span>{{item.promotionLabel}}</span>
            </div>
            <div class="act-time">
                {{item.couponStartTime | formatDate}} -- {{item.couponEndTime | formatDate}}
            </div>
        </li>
    </ul>
</div>
</template>
<script>

    import {Util} from '../commons/util'
    import Server from '../services/Entrance'

    import _ from 'lodash';
    import conf from '@/app.conf.json'

    export default {
        name: 'Vip',
        data () {
            return {
                ticketList: [],
            }
        },
        // 生命周期钩子
        mounted () {
            this.bodyHeight = window.screen.height + 'px';

            $.loadMod(conf.js.coupon).done(function () {});

            document.title = '优惠券';
            if ($.isApp) {
                $.AppReady().done(function (Bridge) {
                    if ($.os.ios && typeof Bridge.documentNavStyle === "function") {
                        Bridge.documentNavStyle();
                    } else if ($.os.android) {
                        Bridge.setText({
                            titleText: '优惠券'
                        });
                    }
                })
            }
        },
        beforeRouteEnter(to, from, next) {

            let urlParams = to.params;

            Util.auth(()=>{
                Server.mycenter.ticketList(urlParams.cityCode, urlParams.storeCode).then(data => {
                    next(vm => {
                        let ticketList = [];

                        _.forEach(data.actInfoList, item => {
                            ticketList.push({
                                activityId: item.activityId,
                                couponDone: false,
                                activitySecretKey: item.activitySecretKey,
                                couponValue: item.couponValue,
                                promotionLabel: item.promotionLabel,
                                couponStartTime: item.couponStartTime,
                                couponEndTime: item.couponEndTime
                            });
                        });

                        vm.ticketList = ticketList;
                    });
                });
            })
        },
        components: {
        },
        methods: {
            coupon(id,  key, couponDone) {

                let _this = this,
                    urlParams = _this.$route.params;

                if (couponDone) {
                    window.location.href = conf.otherPage.guide + '?guideid=' + urlParams.guideId + '&cityId=' + urlParams.cityCode + '&storeCode=' + urlParams.storeCode;
                } else {
                    Util.auth(() => {
                        if (typeof coupon == 'undefined') {
                            $.loadMod(conf.js.coupon).done(function () {
                                hook(id, key);
                            });
                        } else {
                            hook(id, key);
                        }
                    });
                }

                function hook(id, key) {

                    coupon.receive.receiveCoupon({
                        actId: id,
                        actKey: key,
                        cityId: urlParams.cityCode,
                        sourceId: '6002'
                    }, function (res) {
                        if (res.resultCode == '0' || res.resultCode == '6') {
                            _.forEach(_this.ticketList, item => {
                                if (item.activityId == id) {
                                    item.couponDone = true;
                                }
                            });
                        } else if (res.resultCode != '1001' && res.resultCode != '1002' && res.resultCode != '1003' && res.resultCode != '1004' && res.resultCode != '2004' && res.resultCode != '2005' && res.resultCode != '2006') {
                        }
                    })
                }
            }
        }
    }
</script>
<style scoped>
    #ticket-page {
        padding-top: 30px;
        ul {
            padding: 0 43px;
        }
    }
    .ticket-list {
        margin-bottom: 28px;
        background: url("../assets/ticket_1.png");
        width: 664px;
        height: 200px;
        background-size: 664px 200px;

        &.active {
             background: url("../assets/ticket_2.png");
             background-size: 664px 200px;
        }
    }
    .ticket-h {
        padding: 32px 0 18px 36px;
        color: #ffffff;
        font-size: 64px;
        font-weight: 900;

        span:nth-of-type(1) {
            font-size: 44px;
            font-weight: 100;
        }
        span:nth-of-type(3) {
            font-size: 22px;
            color: #c75656;
            font-weight: 100;
        }
    }
    .act-time {
        text-indent: 36px;
        font-size: 22px;
        color: #c75656;
        font-weight: 100;
    }
</style>



// WEBPACK FOOTER //
// src/components/Ticket.vue